import { useState, useEffect } from 'react';
import firebaseService from '../services/firebaseService';

export function useCatches(user) {
  const [catches, setCatches] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!user) {
      setCatches([]);
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    const unsubscribe = firebaseService.subscribeToCatches((catches) => {
      setCatches(catches);
      setLoading(false);
    });

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [user]);

  return {
    catches,
    loading,
    error
  };
}